import Updater from './Updater';
import * as is from 'Services/Misc/is';
import { CONFIGURATION } from 'StateEvents';
import { getInstance } from 'StateManager';
import { getCampaignIDFromIframe, getNielsenImpressionPixel } from 'Services/Misc/survey';

export default class ConfigUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(CONFIGURATION);
  }

  updateState(newState, event) {
    newState.configuration_parsed = true;
    newState.configuration = 
      Object
        .keys(newState.configuration)
        .reduce( (config, key) => {
          if(is.obj(newState.configuration[key])) {
            config[key] = Object.assign({}, newState.configuration[key], event.args[key]);
          } else if(is.arr(newState.configuration[key])) {
            config[key] = event.args[key];
          } else if(is.str(newState.configuration[key] && event.args[key])) {
            config[key] = event.args[key];
          }
          
          return config;
        }, {});

    if(event.args.UI && !is.num(event.args.UI.viewAt)) {
      newState.configuration.UI.viewAt = newState.configuration.UI.skip ? newState.configuration.UI.viewAt : 0;
    }

    if(newState.configuration.UI && is.def(newState.configuration.UI.survey)) {
      const campaignID = getCampaignIDFromIframe(newState.configuration.UI.survey);
      newState.configuration.Events.impression.push({ 
        src: getNielsenImpressionPixel(newState.configuration.Ad_Context, campaignID),
        format: 'pixel'
      });
    }

    return newState;
  }
}

getInstance().registerUpdater(new ConfigUpdater());


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/ConfigUpdater.js